import '../scss/frontend.scss';
import ClipboardJS from 'clipboard';
import { scrollActions, appHeight, handleSelectGuidesChange, anchorLinkScroll, initializeUserway, } from './parts/helpers';
import eventsHandler from './parts/events-handler';
import initCustomSelect from './components/custom-select';
import { detectOs } from './components/detect-os';
import { initForm, initTrialFormHandler } from './components/form';
import { getCookie } from './components/cookie';
require('fslightbox');
window.document.addEventListener('DOMContentLoaded', appHeight);
window.addEventListener('load', () => {
    initCustomSelect();
    scrollActions();
    eventsHandler();
    detectOs();
    initForm();
    initTrialFormHandler();
    new ClipboardJS('.btn-copy');
    anchorLinkScroll('.js-anchor-click', 80);
    const selectGuides = document.querySelector('.js-select-guides');
    selectGuides && selectGuides.addEventListener('change', handleSelectGuidesChange);
    if (!getCookie('cookieConsent')) {
        document.getElementById('cookieConsent').style.display = 'inline-flex';
    }
});
window.addEventListener('resize', appHeight);
window.onscroll = function () {
    initializeUserway();
    scrollActions();
};
document.addEventListener('mousemove', () => {
    initializeUserway();
});
document.addEventListener('click', () => {
    initializeUserway();
});
